import React from 'react';
import { CardMedia } from '@material-ui/core';

import Img from 'retired/Img';

import { Opportunity } from '../types';
import { getCategoryIconData } from '../OpportunityCard/getCategoryIconData';

export const OpportunityImage = ({ opportunity }: { opportunity: Opportunity }) => {
  const mainPicture = opportunity.pictures?.[0];
  if (mainPicture) {
    return (
      <CardMedia
        style={{ height: 300, borderRadius: 12 }}
        image={mainPicture}
        title={opportunity.name}
      />
    );
  }
  const fallbackIconData = getCategoryIconData(opportunity.categories || []);
  return (
    <div
      style={{
        width: '100%',
        height: 300,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: fallbackIconData.hexCode,
        borderRadius: 12,
      }}
    >
      <Img src={fallbackIconData.icon} width={60} alt={opportunity.name} />
    </div>
  );
};
